import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _createRefundRequest = { refund: '_refund' };
var _createRefundResponse = { refund: '_refund' };
var _getRefundabilityRequest = {};
var _getRefundabilityResponse = {};
var _getRefundRequest = {};
var _getRefundResponse = { refund: '_refund' };
var _queryRefundsRequest = {};
var _queryRefundsResponse = { refunds: '_refund' };
var _refund = {
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
};
var _updateExtendedFieldsRequest = {};
var _updateExtendedFieldsResponse = { refund: '_refund' };
function resolveWixPaymentsRefundsV1RefundServiceUrl(opts) {
    var domainToMappings = {
        'manage._base_domain_': [
            {
                srcPath: '/_api/payments/refunds/v1',
                destPath: '/v1',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/**
 * Creates a refund.
 * Refunding process starts immediately after refund entity is created.
 *
 * If amount and currency are not specified,
 * refund is created for full charge amount.
 * If amount is specified, you also need to specify currency,
 * and it should be the same as charge currency.
 *
 * The call blocks until refund status transitions from `STARTING`.
 * Read more about refund statuses in this
 * [article](<https://dev.wix.com/docs/rest/business-management/payments/refunds/introduction#lifecycle-of-a-refund>).
 */
export function createRefund(payload) {
    var _a = serializer(_createRefundRequest, { _refund: _refund }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createRefundResponse, { _refund: _refund }).fromJSON;
    function __createRefund(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.payments.refunds.v1.refund',
            method: 'POST',
            methodFqn: 'wix.payments.refunds.v1.RefundService.CreateRefund',
            url: resolveWixPaymentsRefundsV1RefundServiceUrl({
                protoPath: '/v1/refunds',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createRefund.fromReq = fromReq;
    __createRefund.__isAmbassador = true;
    return __createRefund;
}
/** Retrieves a refund. */
export function getRefund(payload) {
    var _a = serializer(_getRefundRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getRefundResponse, { _refund: _refund }).fromJSON;
    function __getRefund(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.payments.refunds.v1.refund',
            method: 'GET',
            methodFqn: 'wix.payments.refunds.v1.RefundService.GetRefund',
            url: resolveWixPaymentsRefundsV1RefundServiceUrl({
                protoPath: '/v1/refunds/{refundId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getRefund.fromReq = fromReq;
    __getRefund.__isAmbassador = true;
    return __getRefund;
}
/**
 * Retrieves a list of refunds, given the provided [paging, filtering, and sorting][1].
 *
 * Up to 1,000 Refunds can be returned per request.
 *
 * To learn how to query refunds, see [API Query Language][2].
 *
 * [1]: https://dev.wix.com/api/rest/getting-started/sorting-and-paging
 * [2]: https://dev.wix.com/api/rest/getting-started/api-query-language
 */
export function queryRefunds(payload) {
    var _a = serializer(_queryRefundsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryRefundsResponse, { _refund: _refund }).fromJSON;
    function __queryRefunds(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.payments.refunds.v1.refund',
            method: 'POST',
            methodFqn: 'wix.payments.refunds.v1.RefundService.QueryRefunds',
            url: resolveWixPaymentsRefundsV1RefundServiceUrl({
                protoPath: '/v1/refunds/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryRefunds.fromReq = fromReq;
    __queryRefunds.__isAmbassador = true;
    return __queryRefunds;
}
/** Updates extended fields of a refund without incrementing revision. */
export function updateExtendedFields(payload) {
    var _a = serializer(_updateExtendedFieldsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateExtendedFieldsResponse, {
        _refund: _refund,
    }).fromJSON;
    function __updateExtendedFields(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.payments.refunds.v1.refund',
            method: 'POST',
            methodFqn: 'wix.payments.refunds.v1.RefundService.UpdateExtendedFields',
            url: resolveWixPaymentsRefundsV1RefundServiceUrl({
                protoPath: '/v1/refunds/{id}/update-extended-fields',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateExtendedFields.fromReq = fromReq;
    __updateExtendedFields.__isAmbassador = true;
    return __updateExtendedFields;
}
/**
 * Calculates refundability for a charge.
 *
 * Read more about refundability in this
 * [article](<https://dev.wix.com/docs/rest/business-management/payments/refunds/introduction#refundability>).
 */
export function getRefundability(payload) {
    var _a = serializer(_getRefundabilityRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getRefundabilityResponse, {}).fromJSON;
    function __getRefundability(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.payments.refunds.v1.refund',
            method: 'GET',
            methodFqn: 'wix.payments.refunds.v1.RefundService.GetRefundability',
            url: resolveWixPaymentsRefundsV1RefundServiceUrl({
                protoPath: '/v1/refunds/refundabilities/charge-id/{chargeId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getRefundability.fromReq = fromReq;
    __getRefundability.__isAmbassador = true;
    return __getRefundability;
}
//# sourceMappingURL=http.impl.js.map